import React, { useState } from 'react'
import { FormControl, Button } from 'react-bootstrap'
import { Recording } from '../../models'

const ReuploadForm = () => {
  const [meetingId, setMeetingId] = useState('')

  const handleReupload = async () => {
    try {
      await Recording.reupload(meetingId)

      alert('Reuploaded')
    } catch (e) {
      alert(e.message)
    }
  }

  const isAdmin = window.localStorage.getItem('role') === 'ADMIN'
  if (!isAdmin) return false

  return (
    <div className="w-100 d-inline-flex mt-3 align-items-start">
      <FormControl
        className="w-50 me-2"
        placeholder="Meeting ID"
        onChange={(e) => setMeetingId(e.target.value)}
      />
      <Button onClick={handleReupload}>Reupload</Button>
    </div>
  )
}

export { ReuploadForm }
